import { useState } from "react";
import { LIMITS } from "@psplit/ledger-core";
import { repo } from "../lib/repo.js";
import { looksLikeVpa } from "../lib/money.js";
import { errorMessage } from "../lib/errors.js";

export function Onboard() {
  const [name, setName] = useState("");
  const [vpa, setVpa] = useState("");
  const [restore, setRestore] = useState(false);
  const [backup, setBackup] = useState("");
  const [error, setError] = useState("");

  const create = async () => {
    setError("");
    if (name.trim() === "") return setError("Tell your friends who you are.");
    if (vpa.trim() !== "" && !looksLikeVpa(vpa.trim())) {
      return setError("That UPI id does not look valid (name@bank). Leave it empty to add later.");
    }
    await repo.setIdentity(name.trim(), vpa.trim());
  };

  const doRestore = async () => {
    setError("");
    try {
      await repo.importIdentity(backup);
    } catch (e) {
      setError(errorMessage(e));
    }
  };

  return (
    <div className="page center">
      <h1 className="brand">PaisaSplit</h1>
      <p className="tagline">
        Your group's khata, kept on your phones. No account, no company server:
        every entry signed, nothing quietly rewritten.
      </p>
      {!restore ? (
        <div className="card">
          <label>
            Your name
            <input value={name} onChange={(e) => setName(e.target.value)} maxLength={LIMITS.name} placeholder="e.g. Vishal" />
          </label>
          <label>
            UPI id (optional - lets friends pay you in one tap)
            <input value={vpa} onChange={(e) => setVpa(e.target.value)} maxLength={LIMITS.vpa} placeholder="you@bank" />
          </label>
          <button className="btn primary" onClick={() => void create()}>
            Get started
          </button>
          <button className="btn link" onClick={() => setRestore(true)}>
            I have an identity backup
          </button>
        </div>
      ) : (
        <div className="card">
          <label>
            Paste your identity backup (JSON)
            <textarea value={backup} onChange={(e) => setBackup(e.target.value)} rows={5} />
          </label>
          <button className="btn primary" onClick={() => void doRestore()}>
            Restore identity
          </button>
          <button className="btn link" onClick={() => setRestore(false)}>
            Back
          </button>
        </div>
      )}
      {error !== "" && <div className="error">{error}</div>}
      <p className="fineprint">
        Your identity is a key pair generated on this device. It never leaves it unless
        you export a backup - there is nothing to sign up for.
      </p>
    </div>
  );
}
